import { Directive, input } from '@angular/core';

@Directive({
  selector: '[appCancelColor]',
  standalone: true,
  host: {
    '[class.cancel-text]': 'appCancelColor()',
  },
})
export class CancelColorDirective {
  readonly appCancelColor = input(false);
}
